// extracted by mini-css-extract-plugin
export default {"passenger_container":"passenger_passenger_container__-Cb6z"};